import { ActionBase } from '../../../core/store/action/ActionBase';

export const CONFIGURE_REPORTING_SUCCESS = '[Submission] Configure Reporting Success';

export class ConfigureReportingSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CONFIGURE_REPORTING_SUCCESS;
}



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/ConfigureReportingSuccessAction.ts